class Footer {

}

export default Footer;
